import axios from "axios";
import { API_URL } from "@/config/api";

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

export const notificationService = {
  async list() {
    return (await api.get("/notifications")).data.data;
  },
  async markRead(notificationUuid) {
    return (await api.patch(`/notifications/${notificationUuid}/read`)).data.data;
  },
};
